import { render } from "./RangeBarChart.vue?vue&type=template&id=288a8f7a"
import script from "./RangeBarChart.vue?vue&type=script&lang=js"
export * from "./RangeBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__